import * as React from 'react';

const SvgDateRangePicker = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={'1em'}
    height={'1em'}
    viewBox={'0 0 25.2 28'}
    {...props}
  >
    <path
      fill={'currentColor'}
      d='M4.2 28H21a4.2 4.2 0 0 0 4.2-4.2V7a2.8 2.8 0 0 0-2.8-2.8h-2.8V1.4a1.4 1.4 0 1 0-2.8 0v2.8H8.4V1.4a1.4 1.4 0 1 0-2.8 0v2.8H2.8A2.8 2.8 0 0 0 0 7v16.8A4.2 4.2 0 0 0 4.2 28ZM2.8 14.7a.7.7 0 0 1 .7-.7h18.2a.7.7 0 0 1 .7.7v9.1a1.4 1.4 0 0 1-1.4 1.4H4.2a1.4 1.4 0 0 1-1.4-1.4Z'
    />
  </svg>
);
export default SvgDateRangePicker;
